import React from "react";
import { Card, Button, Label } from "@/components/ui";
import { fmtDate } from "@/lib/helpers";
import { ExternalLink } from "lucide-react";
import { STATUSES, nextStatus, statusLabel, riskColor } from "./claimStatus";

export function ClaimCard({ c, onDraft, onView, onAdvance, onOpenAttachment }) {
  const next = nextStatus(c.status);
  return (
    <Card>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-semibold text-ink">{c.provider}</div>
          <div className="text-sm text-subtle">${Number(c.amount_billed || 0).toFixed(2)}{c.date_of_service ? ` · ${c.date_of_service}` : ""} · {fmtDate(c.created_at)}</div>
        </div>
        <span className={`text-[11px] font-bold uppercase text-white px-2.5 py-1 rounded-full ${riskColor(c.analysis?.risk || "low")}`}>{c.analysis?.risk || "low"} risk</span>
      </div>

      {c.analysis?.flags?.length > 0 && (
        <div className="mt-3"><Label>Flags</Label>{c.analysis.flags.map((f, i) => <div key={`${c.id}-flag-${i}`} className="text-sm text-ink">• {f}</div>)}</div>
      )}
      {c.analysis?.rationale && <div className="mt-3"><Label>Rationale</Label><p className="text-sm text-ink">{c.analysis.rationale}</p></div>}
      {c.line_items?.length > 0 && (
        <div className="mt-3"><Label>Extracted line items</Label>
          {c.line_items.slice(0, 4).map((li, i) => (
            <div key={`${c.id}-li-${i}`} className="flex justify-between text-sm py-0.5">
              <span className="truncate flex-1">{li.code ? `${li.code} · ` : ""}{li.description || "—"}</span>
              <span className="font-semibold">${Number(li.charge || 0).toFixed(2)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="flex items-center mt-4 pt-3 border-t border-line">
        {STATUSES.map((s, i) => {
          const done = STATUSES.indexOf(c.status) >= i;
          return (
            <div key={s} className="flex-1 flex flex-col items-center">
              <span className={`w-3 h-3 rounded-full ${done ? "bg-mint" : "bg-line border border-line"}`} />
              <span className="text-[10px] uppercase font-semibold text-subtle mt-1">{statusLabel(s)}</span>
            </div>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-2 mt-4">
        {c.appeal_letter ? (
          <Button variant="secondary" data-testid={`view-letter-${c.id}`} onClick={onView}>View appeal letter</Button>
        ) : (
          <Button data-testid={`draft-appeal-${c.id}`} onClick={onDraft}>Draft appeal (AI)</Button>
        )}
        {next && (
          <Button variant="ghost" data-testid={`advance-status-${c.id}`} onClick={onAdvance}>Mark {statusLabel(next)}</Button>
        )}
      </div>

      {c.attachments?.length > 0 && (
        <div className="mt-3 pt-3 border-t border-line">
          <Label>Evidence attached</Label>
          {c.attachments.map((a) => (
            <button key={a.id} data-testid={`open-attachment-${a.id}`} onClick={() => onOpenAttachment(a.s3_key)}
              className="flex items-center gap-2 text-sm text-brand hover:underline mt-1">
              <ExternalLink className="w-3.5 h-3.5" /> {a.label || a.filename}
            </button>
          ))}
        </div>
      )}
    </Card>
  );
}
